import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function PropertyFind() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">고객이 원하는 매물도, 새로운 매물도 이실장이 알아서 척척 찾아줘요</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<div className="group_view"><Image className="img_guide" src="/image/desktop/popup/property02_01.png" alt={"\uACE0\uAC1D \uB9DE\uCDA4\uB9E4\uBB3C \uD654\uBA74"} width={100} height={100} /></div></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}